import { render, staticRenderFns } from "./person_surveys.vue?vue&type=template&id=65af682a&scoped=true&"
import script from "./person_surveys.vue?vue&type=script&lang=js&"
export * from "./person_surveys.vue?vue&type=script&lang=js&"
import style0 from "./person_surveys.vue?vue&type=style&index=0&id=65af682a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65af682a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65af682a')) {
      api.createRecord('65af682a', component.options)
    } else {
      api.reload('65af682a', component.options)
    }
    module.hot.accept("./person_surveys.vue?vue&type=template&id=65af682a&scoped=true&", function () {
      api.rerender('65af682a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/profile/person_surveys.vue"
export default component.exports